import { createContext } from 'react'

export interface Auth {
  authed: boolean
  login: (token: string) => void
  logout: () => void
}

export const AuthContext = createContext<Auth | null>(null)
